/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Paper,
  Typography,
  Divider,
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  FormControlLabel,
  Switch,
} from "@material-ui/core";

import FDropDown from "../../../fluid/Elements/Inputs/FDropDown";
import Actions from "../../../fluid/Actions/ActionFactory";
import AddWebService from "../../WebService/AddWebService";
import { withRouter } from "react-router-dom";
import ErrorMessageAlert from "../../../traditional/Utilities/ErrorMessageAlert";
import { Event } from "@material-ui/icons/Event";
import { allowedByOpop } from "../../Security/SecureCheck";

const styles = (theme) => ({
  text_field: {
    width: "100%",
  },
});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

class CreateIU extends Component {
  state = {
    iu_name: "",
    iu_name_error: false,
    iu_name_helper_text: "",
    iu_key: "",
    iu_key_error: false,
    iu_key_helper_text: "",
    iu_type: "",
    // iu_type_error: false,
    // iu_type_helper_text: "Choose the Information Unit Type",
    ws: "",
    ws_error: false,
    ws_helper_text: "",
    adaptors: [],
    adaptor_error: false,
    adapter_retrieve_error_text: "Error retreiving Adaptors.",
    add_web_service: false,
    content_types: [],
    content_type_error: false,
    content_type: "",
    content_type_helper_text:
      "You can override the default content type for the selected adapter.",
    sub_type: "",
    error: false,
    error_message: null,
    errorOpen: false,
    errorInfo: {},
    trainable: false,
  };

  componentWillMount() {
    this.getContentTypes();
    if (this.props.iu_name !== null) {
      Actions("http_request", {
        url:
          "/sainapse/information_channel/" +
          this.props.ic_name +
          "/information_unit/" +
          this.props.iu_name,
        method: "get",
        data: {},
      }).then((res) => {
        console.log("Fetching IU: ", res.data.result);
        let result = res.data.result;
        this.setState({
          ...this.state,
          iu_name: result.name,
          // content_type: result.type,
          // iu_key: result.key,
        });
      });
    }
  }

  componentDidMount() {
    const contentHeight = this.props.maxHeight;
    this.setState({ ...this.state, content_height: contentHeight });
  }

  heading = React.createRef();
  footer = React.createRef();

  getContentTypes = () => {
    Actions("http_request", {
      url: "/sainapse/content_types",
      method: "get",
      data: {},
    })
      .then((res) => {
        console.log("Content Types :", res.data.result);
        this.setState({ ...this.state, content_types: res.data.result });
      })
      .catch((err) => {
        this.setState({ ...this.state, content_type_error: true });
      });
  };

  handleChange = (value, state_key) => {
    this.setState(
      {
        ...this.state,
        [state_key]: value,
      },
      () => {
        if (state_key === "ws") {
          this.validateField("ws");
        }
        if (state_key === "iu_key") {
          this.setTypeSubType(value);
        }
        if (state_key === "content_type") {
          let type_index = this.state.content_types.findIndex(
            (el) => el.type === value
          );
          this.setState(
            {
              ...this.state,
              sub_type: this.state.content_types[type_index].sub_types,
            },
            () => {
              this.validateField(state_key);
              console.log("Create IU State: ", this.state);
            }
          );
        }
      }
    );
  };

  closeWebServiceDialog = () => {
    this.setState({ ...this.state, add_web_service: false });
  };

  openWebServiceDialog = () => {
    this.setState({ ...this.state, add_web_service: true });
  };

  closeError = () => {
    if (this.state.error_message.response.status == 404) {
      this.props.history.push({
        pathname: "/create-ic",
      });
    } else {
      this.setState({ ...this.state, error: false, error_message: null });
    }
  };

  createAPIData = () => {
    let data = {
      name: this.state.iu_name,
      key: this.state.iu_key,
      type: this.state.content_type,
      sub_type: this.state.sub_type,
      ws: {
        name: this.state.ws,
      },
    };

    if (this.state.trainable) {
      data.config_type = "Trainable";
    }

    return data;
  };

  createIU = () => {
    Actions("http_request", {
      url:
        "/sainapse/information_channel/" +
        this.props.ic_name +
        "/information_unit",
      method: "post",
      data: this.createAPIData(),
    })
      .then((res) => {
        console.log(res);
        this.setState({ ...this.state, iu_name: res.data.result.name }, () =>
          this.props.handleNext({
            iu_name: this.state.iu_name,
            ws_name: this.state.ws,
          })
        );
      })
      .catch((err) => {
        let response = err.response.data;
        if (err.response.status == 404) {
          let errorMessage =
            "Information channel not found with this name :: " +
            this.props.ic_name;
          if (response.message == errorMessage) {
            this.setState({
              error: true,
              error_message: err,
            });
          }
        }
        if (Array.isArray(response.errors)) {
          response.errors.map((error) => {
            this.setState({
              ...this.state,
              ["iu_" + error.attribute + "_error"]: true,
              ["iu_" + error.attribute + "_helper_text"]: error.message,
            });
          });
        }
      });
  };

  validateField = (field) => {
    if (this.state[field] !== "") {
      let error = false;
      let dfltHelperText = "";
      if (field === "content_type") {
        dfltHelperText =
          "You can override the default content type for the selected adapter.";
      }
      this.setState({
        [field + "_error"]: error,
        [field + "_helper_text"]: dfltHelperText,
      });
      return true;
    } else {
      let error = true;

      this.setState({
        [field + "_error"]: error,
      });
      if (field === "iu_name") {
        this.setState({
          [field + "_helper_text"]: "Please enter a name",
        });
      } else {
        this.setState({
          [field + "_helper_text"]: "Please select a value from the list",
        });
      }
      return false;
    }
  };

  validateAllFields = () => {
    let fields = ["iu_name", "iu_key", "content_type", "ws"];
    let field_validation = fields.map((field) => {
      return this.validateField(field);
    });

    if (field_validation.filter((field) => field === false).length === 0) {
      return true;
    } else {
      return false;
    }
  };

  validateAndCreateIU = () => {
    console.log("IU State before");
    console.log("Validating IU Fields :", this.validateAllFields());
    if (this.validateAllFields() === true) {
      this.createIU();
    }
  };

  renderAdaptorSelect = () => {
    if (this.state.ws !== "") {
      if (this.state.adaptor_error === false) {
        return (
          <FormControl
            style={{ width: "100%", marginTop: "10px" }}
            error={this.state.iu_key_error}
            required={true}
          >
            <InputLabel id="demo-simple-select-label">
              Choose Adaptor
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={this.state.iu_key}
              onChange={(event) => {
                this.handleChange(event.target.value, "iu_key");
              }}
            >
              {this.renderAdaptors()}
            </Select>
            <FormHelperText>{this.state.iu_key_helper_text}</FormHelperText>
          </FormControl>
        );
      } else {
        return (
          <div style={{ display: "flex", alignItems: "baseline" }}>
            <Typography
              style={{ color: "#f44336", marginTop: "10px" }}
              variant="caption"
            >
              Error retreiving adaptors:{" "}
              {this.state.adapter_retrieve_error_text}
            </Typography>
            <Button
              size="small"
              color="primary"
              onClick={() => this.getAdaptors(this.state.ws)}
            >
              Retry
            </Button>
          </div>
        );
      }
    }
  };

  renderAdaptors = () => {
    let adaptors = this.state.adaptors.map((adaptor) => {
      return <MenuItem value={adaptor.key}>{adaptor.key}</MenuItem>;
    });

    return adaptors;
  };

  getAdaptors = (web_service) => {
    Actions("http_request", {
      url: "/sainapse/web_service/" + web_service + "/adapter",
      method: "get",
      data: {},
    })
      .then((res) => {
        this.setState(
          { ...this.state, adaptors: res.data.result, adaptor_error: false },
          () => console.log("Got Adaptors State: ", this.state)
        );
      })
      .catch((err) => {
        let errorMessage;
        if (err && err.response) {
          let response = err.response.data;

          if (err.response.status === 404) {
            errorMessage = response.message || "Resource not found.";
          } else {
            if (response) {
              if (Array.isArray(response.errors)) {
                let adaptorError = response.errors.find(
                  (error) => error.attribute == "iu_key"
                );
                if (adaptorError) {
                  errorMessage = adaptorError.message;
                }
              } else if (response.message) {
                errorMessage = response.message;
              } else {
                errorMessage = "Error retreiving Adaptors.";
              }
            }
          }
        } else if (err && err.message) {
          errorMessage = err.message;
        }

        this.setState({
          ...this.state,
          adaptors: [],
          adapter_retrieve_error_text: errorMessage,
          adaptor_error: true,
        });
      });
  };

  setTypeSubType = (key) => {
    let adaptor_index = this.state.adaptors.findIndex(
      (adaptor) => adaptor.key === key
    );

    let type = this.state.adaptors[adaptor_index].type;
    let sub_type = this.state.adaptors[adaptor_index].sub_type;
    console.log(
      "stting sub types",
      this.state.adaptors,
      adaptor_index,
      sub_type
    );

    this.setState(
      { ...this.state, content_type: type, sub_type: sub_type },
      () => {
        this.validateField("iu_key");
        this.validateField("content_type");
        console.log("Create IU State: ", this.state);
      }
    );
  };

  renderTypeSelect = () => {
    if (this.state.ws !== "") {
      if (this.state.iu_key !== "") {
        return (
          <div style={{ width: "100%", marginTop: "10px" }}>
            <FormControl
              style={{ width: "100%" }}
              error={this.state.content_type_error}
              required={true}
            >
              <InputLabel id="demo-simple-select-label">
                Content Type
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={this.state.content_type}
                onChange={(event) => {
                  this.handleChange(event.target.value, "content_type");
                }}
              >
                {this.renderTypes()}
              </Select>
              <FormHelperText>
                {this.state.content_type_helper_text}
              </FormHelperText>
            </FormControl>
            <Button
              size="small"
              color="primary"
              onClick={() => this.setTypeSubType(this.state.iu_key)}
            >
              Reset To Default
            </Button>
          </div>
        );
      }
    }
  };

  renderTypes = () => {
    let types = this.state.content_types.map((typeObj) => {
      return <MenuItem value={typeObj.type}>{typeObj.annotation}</MenuItem>;
    });

    return types;
  };

  toggleTrainable = (event) => {
    this.setState({ ...this.state, trainable: !this.state.trainable });
  };

  getDisableStatus = (icName) => {
    
    return !allowedByOpop({
      operation : "/sainapse/information_channel/{ic_name}/information_unit",
      method : "POST",
      operands : [
        {
          attrName: "ic_name",
          value : icName
        }]
    })
  };

  getHelperText= (icName) => {
    var accessObject = {
        operation : "/sainapse/information_channel/{ic_name}/information_unit",
        method : "POST",
        operands : [{
          attrName: "ic_name",
          value : icName
        }]
    }
    return !allowedByOpop(accessObject) ? 'User does not have sufficient privileges' : ''
}



  render() {
    const { classes } = this.props;
    return (
      <div
        style={{
          width: "100%",
          height: this.props.maxHeight,
          backgroundColor: "#F0F0F0",
          display: "flex",
          flexDirection: "row",
          justifyItems: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            // height: this.props.maxHeight,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: this.state.content_height,
            maxHeight: this.state.content_height,
            overflow: "scroll",
            padding: "8px",
          }}
        >
          <Paper
            elevation={4}
            style={{
              padding: "5px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div style={{ width: "100%" }}>
              <Typography variant="h6">Create Information Unit</Typography>
              <Divider style={{ marginTop: "5px", marginBottom: "10px" }} />
            </div>
            <ThemeProvider theme={blue_theme}>
              <TextField
                key="iu_name"
                className={classes.text_field}
                disabled={this.state.submission}
                name="Information Unit Name"
                defaultValue=""
                multiline={false}
                label="Information Unit Name"
                value={this.state.iu_name}
                error={this.state.iu_name_error}
                type="string"
                required={true}
                variant="standard"
                size="small"
                helperText={this.state.iu_name_helper_text}
                onChange={(event) =>
                  this.handleChange(event.target.value, "iu_name")
                }
                onBlur={() => this.validateField("iu_name")}
              />
              <div style={{ width: "100%", marginTop: "15px" }}>
                <FDropDown
                  instance={{
                    label: "Edge Service",
                    helper_text: this.state.ws_helper_text,
                    props: {
                      width: "100",
                      variant: "standard",
                    },
                    value_store: ["ws"],
                    eval_value: "",
                    error: this.state.ws_error,
                    default_value: this.state.wv_server,
                    async_values: true,
                    api_config: {
                      args: {
                        url: "/sainapse/web_service",
                        method: "get",
                        data: {},
                      },
                      response_key: "result",
                      val_key: "name",
                      label_key: "",
                    },
                    values: [],
                    render_condition: "",
                    mandatory: true,
                    onBlur: () => this.validateField("ws"),
                  }}
                  handleChange={(state_key, value) => {
                    this.handleChange(value, state_key[0]);
                    this.getAdaptors(value);
                  }}
                />
                <Typography
                  style={{ margin: 0, padding: 0, marginBottom: "5px" }}
                  variant="body2"
                >
                  If the Edge Service you are looking for is not in the list,
                  please register a new Edge Service below.
                </Typography>
                <Button
                  size="small"
                  color="primary"
                  onClick={this.openWebServiceDialog}
                >
                  Register A New Edge Service
                </Button>
              </div>
              {this.renderAdaptorSelect()}
              {this.renderTypeSelect()}
              <div style={{ width: "100%", marginTop: "10px" }}>
                <div>
                  <ThemeProvider theme={blue_theme}>
                    <FormControl>
                      <FormControlLabel
                        control={
                          <Switch
                            style={{ float: "right" }}
                            checked={this.state.trainable}
                            onChange={this.toggleTrainable}
                            color="primary"
                          />
                        }
                        label="Trainable"
                        labelPlacement="end"
                      />
                      <FormHelperText>
                        Switch On if this IU can be used for training.
                      </FormHelperText>
                    </FormControl>
                  </ThemeProvider>
                </div>
              </div>
              <ThemeProvider theme={blue_theme}>
                <Button
                  disabled={this.state.iu_key === "" && this.getDisableStatus(this.props.ic_name)}
                  style={{ marginTop: "20px" }}
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={this.validateAndCreateIU}
                  helperText={this.getHelperText(this.props.ic_name)}
                >
                  Submit
                </Button>
              </ThemeProvider>
              <AddWebService
                open={this.state.add_web_service}
                handleClose={this.closeWebServiceDialog}
              />
            </ThemeProvider>
          </Paper>
        </div>
        {/* <div ref = {this.footer} 
                    style = {{
                        display : 'flex', 
                        flexDirection : 'row-reverse',
                        backgroundColor : '#F0F0F0',
                        padding : '8px',
                        borderTop : '1px solid rgba(0,0,0,0.12)',
                    }}>
                    <ThemeProvider theme = {blue_theme}>
                        <Button
                            variant = 'contained'
                            color = 'primary'
                            size = 'small'
                            onClick = {this.validateAndCreateIU}
                        >Submit</Button>
                    </ThemeProvider>
                </div> */}
        {this.state.error === true && (
          <ErrorMessageAlert
            open={this.state.error}
            handleClose={this.closeError}
            errorInfo={this.state.error_message}
          />
        )}
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(CreateIU));
